import { ReactElement } from "react";
import { setTrackingId } from "client/Misc/utils";
import styles from "./List.module.less";
import { PersonAvatar } from "client/Components";
import { getComputedDisplayName } from "client/Features/AddressBook/common";
import { UserIdentityModel, getUserProfileImageUrl } from "client/Api/UserProfile/service";
import { AttendeePreviewModel } from "client/Api/Hub/Events/eventViewer";

export type ListProps = {
	items: readonly AttendeePreviewModel[];
};

export const List = (props: ListProps): ReactElement => {
	const {
		items
	} = props;

	return (
		<ul {...setTrackingId("attendees-list")}>
			{items.map(x => (
				<li
					key={x.user
						.userId
					}
				>
					<Item user={x.user}/>
				</li>
			))}
		</ul>
	);
};
List.displayName="List";

type ItemProps = {
	user: UserIdentityModel;
};

const Item = (props: ItemProps): ReactElement => {
	const {
		user
	} = props;

	const {
		avatarId,
		firstName,
		lastName,
		userId
	} = user;

	const profileImageUrl: string | null = avatarId
		? getUserProfileImageUrl(avatarId)
		: null;

	const {
		initials,
		computedDisplayName
	} = getComputedDisplayName({
		firstName,
		lastName
	});

	return (
		<div
			{...setTrackingId("attendees-list-item", `|${userId}`)}
			className={styles.item}
		>
			<div className={styles.avatar}>
				<PersonAvatar
					trackingId="avatar"
					initials={initials}
					imageSrc={profileImageUrl}
				/>
			</div>
			<div
				{...setTrackingId("title")}
				className={styles.name}
				title={computedDisplayName}
			>
				{computedDisplayName}
			</div>
		</div>
	);
};
Item.displayName="Item";